// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__3ne8p","lastUpdated":"PrivacyPolicy_lastUpdated__QkYjg"};